/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import axios from 'axios';
import _ from 'lodash';
import * as serviceEndPoint from '../../../../SharedModules/services/service';
import * as ActionTypes from './actionTypes';
import { NO_DATA } from '../../../../SharedModules/Errors/constantMessageData';

export const dispatchPlanType = (data) => ({
  type: ActionTypes.GET_PLAN_TYPE_DATA,
  payload: data,
});

// to retain pagination undex
export const setPaginationIndex = (value) => ({
  type: ActionTypes.SET_PAGINATION_INDEX_OUTSTANDING_DISPUTES_QUARTER,
  payload: value,
});

export const setSearchInput = (data) => ({
  type: ActionTypes.SET_SELECTED_OUTSTANDING_DISPUTES_QUARTER,
  payload: data,
});

// Loader
export const setLoading = (value) => ({
  type: ActionTypes.IS_LOADING_OUTSTANDING_DISPUTES_QUARTER,
  isLoading: value,
});

export const getPlanTypeValues = () => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post(serviceEndPoint.GET_COMMON_MANUFACUTRE_DROPDOWNS, {
      codeDomainList: ['PLAN_TYPE_CD'],
    })
    .then((response) => {
      dispatch(setLoading(false));
      return dispatch(dispatchPlanType(response.data));
    })
    .catch(() => {
      dispatch(setLoading(false));
      dispatch(dispatchPlanType([]));
    });
};

// API to get Reabte Program List
export const getRebateProgrameList = (value) => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post(`${serviceEndPoint.SYSTEM_LIST_ALL_DROPDOWN}`, { planType: value })
    .then((response) => {
      dispatch(setLoading(false));
      return response.data.data;
    })
    .catch((response) => {
      dispatch(setLoading(false));
    });
};

// Manufacturer Grid
export const getManufacturerList = (values) => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post(
      `${serviceEndPoint.REBATE_PERCENT_OF_SPEND_MANUFACTURER_GRID}`,
      values
    )
    .then((response) => {
      dispatch(setLoading(false));
      return dispatch({
        type: ActionTypes.GET_MANUFACTURER_LIST_OUTSTANDING_DISPUTES_QUARTER,
        manufacturerList: response.data,
      });
    })
    .catch((response) => {
      dispatch(setLoading(false));
      return response;
    });
};

// To get the defaut selection on the req screen when reopening the req screen
export const refreshOutstandingDispForQuarter = () => ({
  type: ActionTypes.REFRESH_OUTSTANDING_DISPUTE_QUARTER,
  payload: {},
});

export const refreshOutstandingDispForQuarterDisplay = () => ({
  type: ActionTypes.REFRESH_OUTSTANDING_DISPUTE_QUARTER_DISPLAY,
  payload: {},
});

// This action show error message for 5 sec for no contract exists
export const showNoDataMessage = () => (dispatch) => {
  // setTimeout(() => {
  //   dispatch(setSearchInput({ errors: [] }));
  // }, 5000);
  dispatch(
    setSearchInput({
      errors: [
        {
          field: 'noData',
          message: NO_DATA,
        },
      ],
    })
  );
};

export const setOutstandingForQuarter = (data) => ({
  type: ActionTypes.GET_OUTSTANDING_DISPUTES_QUARTER_HEADER,
  outstandingDisputesQuarterHeader: data,
});

// API call for the display screen Header
export const getOustandingDisputesQuarterHeader = (values) => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post(`${serviceEndPoint.OUTSTANDING_DISPUTES_QUARTER_HEADER}`, values)
    .then((response) => {
      dispatch(setLoading(false));
      if (
        response?.data?.outStandingDisputesForQuarterHeaderGridVO.length === 0
      ) {
        dispatch(showNoDataMessage());
      } else {
        return dispatch(
          setOutstandingForQuarter(
            response?.data?.outStandingDisputesForQuarterHeaderGridVO
          )
        );
      }
    })
    .catch((response) => {
      dispatch(setLoading(false));
      return response;
    });
};

// API call for the display screen grid
export const getOustandingDisputesQuarter = (values) => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post(`${serviceEndPoint.OUTSTANDING_DISPUTES_QUARTER}`, values)
    .then((response) => {
      dispatch(setLoading(false));
      return dispatch({
        type: ActionTypes.GET_OUTSTANDING_DISPUTES_QUARTER,
        outstandingDisputesQuarter: response.data,
      });
    })
    .catch((response) => {
      dispatch(setLoading(false));
      return response;
    });
};

export const setMfgOutstandingDisputesForQuarterExportAll = (
  data,
  rebateProgram
) => ({
  type: ActionTypes.SET_EXPORT_ALL_PDF_OUTSTANDING_DISPUTES_QUARTER,
  payload: { data, rebateProgram },
});

export const reportData = (values) => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post(serviceEndPoint.OUTSTANDING_DISPUTES_QUARTER, values)
    .then((response) => {
      dispatch(setLoading(false));

      dispatch(
        setMfgOutstandingDisputesForQuarterExportAll(
          response?.data?.outStandingDisputesForQuarterDetailsVO,
          values.rebateProgramCd
        )
      );
    })
    .catch(() => {
      dispatch(setLoading(false));
      dispatch(
        setMfgOutstandingDisputesForQuarterExportAll([], values.rebateProgramCd)
      );
    });
};

export const getMfgOutstandingDisputesForQuarterExportAll =
  ({ quarter, rebatePrograms, mfgId, aiAll }) =>
  (dispatch) => {
    for (let i = 0; i < rebatePrograms?.length; i += 1) {
      const values = {
        quarter,
        mfgId,
        aiAll,
        rebateProgramCd: rebatePrograms[i].rebateProgramCd,
      };

      dispatch(reportData(values));
    }
  };
export const clearReduxOutStandingDisputesQuarterOfDaysSearchScreen =
  () => (dispatch) => {
    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
    dispatch(setSearchInput({ errors: [] }));
    dispatch(setLoading(false));
    dispatch(dispatchPlanType([]));
    dispatch({
      type: ActionTypes.GET_MANUFACTURER_LIST_OUTSTANDING_DISPUTES_QUARTER,
      manufacturerList: [],
    });
    if (
      !updateTabs.filter(
        (x) => x.navTo === '/displayOutstandingDisputesForQuarter'
      ).length > 0
    ) {
      dispatch(
        setSearchInput({
          errors: [],
          rebateProgramName: '',
          isLoading: false,
          manufacturerList: [],
          outstandingDisputesQuarter: [],
          outstandingDisputesQuarterHeader: [],
          quarterValue: '',
          isAllManufacturersSelected: false,
          allRebateProgram: false,
          exportAllData: {},
          manufacturerSelected: [],
          searchScreenVar: {
            rebateProgramValue: '',
            selectedPlanType: '',
            quarterValue: '',
            allRebateProgram: false,
            rebateProgrameName: '',
            isAllManufacturersSelected: true,
            // scrollDownManufacturers: true,
          },
        })
      );
    }
  };
export const clearReduxOutStandingDisputesQuarterOfDaysDetailsScreen =
  () => (dispatch) => {
    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));

    if (
      !updateTabs.filter((x) => x.navTo === '/outstandingDisputesForQuarter')
        .length > 0
    ) {
      dispatch(
        setSearchInput({
          errors: [],

          rebateProgramName: '',
          isLoading: false,
          manufacturerList: [],
          outstandingDisputesQuarter: [],
          outstandingDisputesQuarterHeader: [],
          quarterValue: '',
          isAllManufacturersSelected: false,
          allRebateProgram: false,
          exportAllData: {},
          manufacturerSelected: [],
          searchScreenVar: {
            rebateProgramValue: '',
            selectedPlanType: '',
            quarterValue: '',
            allRebateProgram: false,
            rebateProgrameName: '',
            isAllManufacturersSelected: true,
            // scrollDownManufacturers: true,
          },
        })
      );
    }
    dispatch(setLoading(false));
    dispatch({
      type: ActionTypes.GET_OUTSTANDING_DISPUTES_QUARTER,
      outstandingDisputesQuarter: [],
    });
    dispatch(setPaginationIndex(0));
  };
